// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__32CUl","rootSmall":"AddTileButton_rootSmall__3Nrhy"};